:where(.container) {
  background-color: var(--dds-color-surface-inverse-default);
}
